var cilHouse = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M408,406.545V248H288V406.545ZM320,280h56v94.545H320Z' class='ci-primary'/><path fill='var(--ci-primary-color, currentColor)' d='M271.078,33.749a34,34,0,0,0-47.066.984L32,226.745V496H144V336h64V496H480V225.958ZM448,464H240V304H112V464H64V240L249.412,57.356V57.3L448,240Z' class='ci-primary'/>"];

export { cilHouse };

